<template>
    <b-modal size='lg' scrollable no-fade id="modal-add-participant" ref="modal-add-participant" title="Adicionar Participantes">
        <b-row class="mb-2">
          <b-col lg="12">
            <b-form-input placeholder="Procurar..." type="text" v-model="search"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b-table ref="tblAddParcipants"
              :filter="search" 
              :fields="fields" 
              :items="users"
              :select-mode="'multi'"
              @row-selected="onRowSelected"
              striped bordered selectable hover responsive small head-variant="dark" selected-variant="primary">
              <template v-slot:table-colgroup="scope">
                <col v-for="field in scope.fields" :key="field.key" :style="colWidths(field)" />
              </template>
              <template v-slot:cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <span style='width: 20px' aria-hidden="true">&check;</span>
                  <span style='width: 20px' class="sr-only">Selected</span>
                </template>
                <template v-else>
                  <span style='width: 20px' aria-hidden="true">&nbsp;</span>
                  <span style='width: 20px' class="sr-only">Not selected</span>
                </template>
              </template>              
            </b-table>
            <p style="font-size:0.6em">**Clique nas linhas para marcar</p>
          </b-col> 
        </b-row>
        <template v-slot:modal-footer>
            <b-button size="sm" class="float-left" @click="selectAll()">Todos</b-button>
            <b-button size="sm" class="float-left" @click="deSelectAll()">Nenhum</b-button>
            <b-button size="sm" @click="selectParticipants()" variant="primary">
              <i class="fas fa-check"></i> Selecionar
            </b-button>
            <b-button size="sm" @click="() => $bvModal.hide('modal-add-participant')">Cancelar</b-button>
        </template>
    </b-modal>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'

export default {
    name: 'AddParticipants',
    data: function(){
      return {
        users:[],
        selected: [],
        search: '',
        fields: [{key: "selected", label:''}, {key: 'name', label: 'Nome'}, {key: 'email', label: 'E-mail'}]
      }
    },
    methods: {
      selectParticipants(){
        if(this.selected.length === 0)
        {
          this.$toasted.show('Selecione ao menos 1 usuário')
          return
        }
        this.$bvModal.hide('modal-add-participant')
        this.$emit("select", this.selected)
      },
      getUsers(){
        axios.get(`${baseApiUrl}/usuarios`).then(
          res => this.users = res.data
        ).catch(showError)
      },
      onRowSelected(items) {
        this.selected = items
      },
      selectAll(){
        this.$refs.tblAddParcipants.selectAllRows()
      },
      deSelectAll(){
        this.$refs.tblAddParcipants.clearSelected()
      },
      colWidths(field) {
        let _width = "inherited";

        if (field.key === "selected") _width = "40px";

        return { width: _width };
      },

    },
    created(){
      this.getUsers()
    }
}
</script>

<style>

</style>